var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgChain = function SvgChain(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.387 62.504c-6.036 0-11.308 3.284-14.159 8.15L37.769 55.956c.809-1.94 1.26-4.066 1.26-6.296s-.451-4.355-1.26-6.296l25.158-14.525c2.772 5.148 8.213 8.657 14.46 8.657 9.052 0 16.415-7.363 16.415-16.415S86.438 4.666 77.387 4.666s-16.415 7.363-16.415 16.415c0 1.281.162 2.523.441 3.722L35.625 39.691c-3.003-3.91-7.711-6.446-13.012-6.446-9.052 0-16.415 7.363-16.415 16.415s7.363 16.415 16.415 16.415c5.301 0 10.01-2.536 13.013-6.448l25.94 14.977a16.31 16.31 0 0 0-.595 4.315c0 9.052 7.363 16.415 16.415 16.415s16.415-7.363 16.415-16.415-7.363-16.415-16.414-16.415z"
  })));
};

export default SvgChain;